/* Rosebound search (Oct 2026). Uses the book filter map (rb-filter-map.js) to:
   1. show "Browse books" pills (trope, genre, creature, setting, mood…) at the top of every search dropdown;
   2. send a search that is just filters ("enemies to lovers", "spicy fae") straight to Shop All Books with those filters on;
   3. rotate example placeholders in search boxes that ask for it (data-rbst-rotate="a|b|c");
   4. on the search results page, show what actually matches first with an honest count, and put Shopify's
      padded "related" results under "You might also like" (Oct 28, 2026).
   5. series (Nov 2, 2026; leading "The", trailing "Trilogy"/"Collection" and one-letter typos ignored since Nov 2 pm): typing a series name ("crescent city", "acotar", "tog") shows that series' books in
      reading order in the dropdown, and Enter on a series name opens the series in reading order. Series names come
      from rb-series-map.json (built by build_series_map.py); the books come live from Shopify (tag:"series:<slug>"). */
(function () {
  if (window.RBST) return;
  var me = document.currentScript;
  window.RBST = { map: me && me.dataset.map, books: (me && me.dataset.books) || '/collections/books', series: me && me.dataset.series };

  var KEYS = { tropes: 'Trope', genre: 'Genre', spice: 'Spice', characters: 'Creature', setting: 'Setting', mood: 'Mood', rep: 'Representation', authors: 'Author', edition: 'Edition' };
  var ORDER = ['tropes', 'genre', 'characters', 'setting', 'mood', 'spice', 'rep', 'authors', 'edition'];
  /* Single words that are safe to jump on. "spicy"/"smut" alone otherwise pull up simmer-pot spices. */
  var JARGON = { e2l: 1, f2l: 1, fwb: 1, thad: 1, slowburn: 1, instalove: 1, romantasy: 1, spicy: 1, smut: 1, smutty: 1, lgbt: 1, 'lgbt+': 1, lgbtq: 1, 'lgbtq+': 1, deluxe: 1 };
  var STOP = { books: 1, book: 1, romance: 1, romances: 1, novel: 1, novels: 1, 'with': 1, and: 1, '+': 1, read: 1, reads: 1 };
  var cands = null;

  function norm(s) { return (s || '').toLowerCase().replace(/[’']/g, "'").replace(/&/g, ' and ').replace(/[^a-z0-9'+\/ ]+/g, ' ').replace(/\s+/g, ' ').trim(); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function preview() { var m = location.search.match(/preview_theme_id=(\d+)/); return m ? '&preview_theme_id=' + m[1] : ''; }
  function isTagSearch(q) { return /^\s*tag\s*:/i.test(q || ''); }

  var ready = fetch(window.RBST.map).then(function (r) { return r.text(); }).then(function (src) {
    var w = {}, d = { querySelector: function () { return null; } };
    new Function('window', 'document', src)(w, d);
    var groups = w.RB_FILTERS.groups, list = [];
    groups.forEach(function (g) {
      if (!KEYS[g.key]) return;
      g.values.forEach(function (v) {
        var canon = norm(v.v);
        [v.v].concat(v.syn || []).forEach(function (word) {
          var n = norm(word);
          if (n.length < 2) return;
          /* "strong" words are safe to jump on: multi-word phrases, shop jargon, or the value's own name.
             Single-word synonyms ("rivals", "boss", "forbidden") are often book titles, so they only suggest. */
          list.push({ g: g, v: v, w: n, strong: n.indexOf(' ') > 0 || !!JARGON[n] || n === canon });
        });
      });
    });
    list.sort(function (a, b) { return b.w.length - a.w.length; });
    cands = list;
  }).catch(function () { cands = []; });

  /* ---------- Series ---------- */
  var series = null, seriesHtml = {};
  /* Words people add around a series name ("crescent city series", "acotar books in order"). */
  var SFILL = /\b(series|books?|saga|in order|reading order|order|all)\b/g;
  /* Readers drop a leading "The"/"A" ("empyrean", "folk of the air"), so it's ignored on both sides. */
  function snorm(s) { return norm(s).replace(/'/g, '').replace(/[\/+]/g, ' ').replace(SFILL, ' ').replace(/\s+/g, ' ').trim().replace(/^(the|a|an) /, ''); }
  /* ...and the descriptor at the end ("Cozy Creek Collection" → "cozy creek"). */
  var SDESC = / (trilogy|duet|duology|cycle|chronicles|collection|universe|quartet|series two)$/;
  var sready = (window.RBST.series ? fetch(window.RBST.series).then(function (r) { return r.json(); }) : Promise.resolve([]))
    .then(function (rows) {
      var list = [];
      rows.forEach(function (r) {
        var keys = [{ k: snorm(r.n), alias: false }], bare = snorm(r.n).replace(SDESC, '');
        if (bare !== keys[0].k && bare.length >= 3) keys.push({ k: bare, alias: false });
        /* A nickname starting with "~" only shows the series in the dropdown; Enter still searches normally
           (used where the nickname is also a book title, e.g. "~fourth wing"). */
        (r.a || []).forEach(function (a) { var nj = a.charAt(0) === '~'; keys.push({ k: snorm(nj ? a.slice(1) : a), alias: true, nojump: nj }); });
        keys.forEach(function (x) { if (x.k.length >= 2) list.push({ row: r, k: x.k, alias: x.alias, nojump: !!x.nojump, multi: x.k.indexOf(' ') > 0 }); });
      });
      series = list;
    }).catch(function () { series = []; });
  var bothReady = Promise.all([ready, sready]);

  /* Best series for what was typed, or null. score 3 = exact name/nickname, 2 = name inside the search or one typo,
     1 = still typing the name ("crescen"). */
  function seriesMatch(q) {
    if (!series || !series.length) return null;
    var qs = snorm(q);
    if (qs.length < 2) return null;
    var best = null;
    function take(c, score) {
      if (!best || score > best.score || (score === best.score && c.k.length < best.c.k.length) ||
          (score === best.score && c.k === best.c.k && c.alias && !c.nojump)) best = { c: c, score: score };
    }
    series.forEach(function (c) {
      if (c.k.length < 3 && !c.alias) return;
      if (qs === c.k) { if (c.k.length >= 3 || c.alias) take(c, 3); return; }
      if (qs.length < 3) return;
      /* Name inside a longer search: "crescent city sarah j maas". Multi-word names or long single words only. */
      if ((c.multi || c.k.length >= 7) && (' ' + qs + ' ').indexOf(' ' + c.k + ' ') > -1) { take(c, 2); return; }
      /* One letter off per word, multi-word names only ("cresent city", "throne of glas"). */
      if (c.multi) {
        var a = qs.split(' '), b = c.k.split(' ');
        if (a.length === b.length) {
          var ok = true, edits = 0;
          for (var i = 0; i < a.length; i++) {
            if (a[i] === b[i]) continue;
            if (a[i].length >= 4 && b[i].length >= 4 && near(a[i], b[i])) { edits++; continue; }
            ok = false; break;
          }
          if (ok && edits > 0 && edits <= 2) { take(c, 2); return; }
        }
      }
      /* One letter off on a single long word ("empryean", "lightlrak"): 7+ letters both sides, and not just an added
         ending ("villains" isn't a typo of "villain"). */
      if (!c.multi && qs.indexOf(' ') < 0 && qs.length >= 7 && c.k.length >= 7 && qs.indexOf(c.k) !== 0 && c.k.indexOf(qs) !== 0 && near(qs, c.k)) { take(c, 2); return; }
      /* Still typing: covers at least half the name, 5+ letters. */
      if (qs.length >= 5 && c.k.indexOf(qs) === 0 && qs.length * 2 >= c.k.length) take(c, 1);
    });
    return best;
  }
  /* Enter goes to the series when the whole search is the series name (or a nickname, or one typo off).
     Single-word names ("hunter", "villain") only show in the dropdown, since they're often titles or tropes. */
  function seriesJump(q) {
    var m = seriesMatch(q);
    if (!m) return null;
    var exactish = m.score === 3 || (m.score === 2 && snorm(q).split(' ').length === m.c.k.split(' ').length);
    return exactish && !m.c.nojump && (m.c.multi || m.c.alias) ? m.c.row : null;
  }
  function seriesUrl(slug) {
    return (window.routes && routes.search_url || '/search') + '?q=' + encodeURIComponent('tag:"series:' + slug + '"') + '&type=product' + preview();
  }
  function seriesCss() {
    if (document.getElementById('rbser-css')) return;
    var st = document.createElement('style');
    st.id = 'rbser-css';
    st.textContent =
      '.rbser .rbser__num { display:block; font-size:1.1rem; letter-spacing:.12em; text-transform:uppercase; color:#aa6d6b; margin-bottom:.2rem; }' +
      '.rbser .rbser__ed { display:block; font-size:1.2rem; color:rgba(var(--color-foreground),.65); margin-top:.2rem; }' +
      '.rbser .rbser__all a { font-weight:600; color:#854a4c; }';
    document.head.appendChild(st);
  }
  function injectSeries(listbox, q) {
    if (listbox.querySelector('[data-rbser]')) return;
    var m = seriesMatch(q);
    if (!m) return;
    var row = m.c.row;
    function place(html) {
      if (!document.body.contains(listbox) || listbox.querySelector('[data-rbser]')) return;
      var d = new DOMParser().parseFromString(html, 'text/html'), box = d.querySelector('[data-rbser-total]');
      var total = box ? +box.getAttribute('data-rbser-total') : 0;
      if (!box || !total) return;
      seriesCss();
      var items = box.innerHTML;
      var more = '<li id="rbser-opt-all" class="predictive-search__list-item rbser__all" role="option" aria-selected="false">' +
        '<a class="predictive-search__item link link--text" tabindex="-1" href="' + esc(seriesUrl(row.s)) + '">' +
        (total > 1 ? 'See all ' + total + ' in reading order' : 'See the series') + ' &rarr;</a></li>';
      var g = '<div class="rbser" data-rbser><h2 class="predictive-search__heading text-body caption-with-letter-spacing" id="rbser-h">Series · ' + esc(row.n) + '</h2>' +
        '<ul class="predictive-search__results-list list-unstyled" role="group" aria-labelledby="rbser-h">' + items + more + '</ul></div>';
      /* A series match means we carry it, so drop the "We can order it" line. */
      var req = listbox.querySelector('[data-rbreq-ac]');
      if (req) req.remove();
      var pills = listbox.querySelector('[data-rbst]');
      if (pills) pills.insertAdjacentHTML('afterend', g); else listbox.insertAdjacentHTML('afterbegin', g);
    }
    if (seriesHtml[row.s]) { place(seriesHtml[row.s]); return; }
    fetch(seriesUrl(row.s) + '&section_id=rb-series-list', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (h) { if (h) { seriesHtml[row.s] = h; place(h); } })
      .catch(function () {});
  }

  function hitValues(c) {
    if (c.v.group === 'spicy' && c.w === 'spicy') return ['3 – Spicy', '4 – Very Spicy', '5 – Scorching'];
    return [c.v.v];
  }
  function hitLabel(c) {
    if (c.g.key === 'spice') return c.w === 'spicy' ? 'Spicy' : c.v.v.replace(/^\d\s*–\s*/, '');
    return c.v.v;
  }

  /* Which filter values does the whole search name? */
  function parse(q) {
    var toks = norm(q).split(' ').filter(Boolean), hits = [], used = {};
    function add(c) { var k = c.g.key + '|' + c.v.v; if (!used[k]) { used[k] = 1; hits.push(c); } }
    /* Exact match of a candidate's words anywhere in the remaining words. */
    function exact(c) {
      var ws = c.w.split(' ');
      for (var i = 0; i + ws.length <= toks.length; i++) {
        if (toks.slice(i, i + ws.length).join(' ') === c.w) { add(c); toks.splice(i, ws.length); return; }
      }
    }
    /* Typo match ("enemis to lovers", "slow burm", "romantsy"): only for safe names — multi-word phrases,
       or single jargon/value names of 6+ letters. Each word of 4+ letters may be one letter off (max 2 per phrase). */
    function fuzzy(c) {
      var ws = c.w.split(' ');
      if (used[c.g.key + '|' + c.v.v] || (ws.length < 2 && c.w.length < 6)) return;
      for (var i = 0; i + ws.length <= toks.length; i++) {
        var ok = true, edits = 0;
        for (var j = 0; j < ws.length; j++) {
          var a = toks[i + j], b = ws[j];
          if (a === b) continue;
          if (a.length >= 4 && b.length >= 4 && near(a, b)) { edits++; continue; }
          ok = false; break;
        }
        if (ok && edits > 0 && edits <= 2) { add(c); toks.splice(i, ws.length); return; }
      }
    }
    var all = cands || [], safe = all.filter(function (c) { return c.strong; }), weak = all.filter(function (c) { return !c.strong; });
    /* Safe names first (exact, then with a typo), so "enemies to lover" isn't swallowed by the loose word "enemies". */
    safe.forEach(exact);
    safe.forEach(fuzzy);
    weak.forEach(exact);
    var rest = toks.filter(function (w) { return w && !STOP[w]; });
    var strong = hits.some(function (h) { return h.strong; });
    var allStrong = hits.length && hits.every(function (h) { return h.strong; });
    return { hits: hits, rest: rest, jump: hits.length > 0 && rest.length === 0 && (allStrong || (hits.length > 1 && strong)) };
  }

  /* True when a and b are one edit apart (add, drop, change or swap two neighbouring letters). */
  function near(a, b) {
    if (Math.abs(a.length - b.length) > 1) return false;
    var i = 0;
    while (i < a.length && i < b.length && a[i] === b[i]) i++;
    if (a.length === b.length) {
      if (a.slice(i + 1) === b.slice(i + 1)) return true;
      return a[i] === b[i + 1] && a[i + 1] === b[i] && a.slice(i + 2) === b.slice(i + 2);
    }
    return a.length > b.length ? a.slice(i + 1) === b.slice(i) : a.slice(i) === b.slice(i + 1);
  }

  function urlFor(hits) {
    var parts = [];
    hits.forEach(function (h) { hitValues(h).forEach(function (v) { parts.push(h.g.key + '|' + v); }); });
    return window.RBST.books + '?rbf=' + encodeURIComponent(parts.join('~')) + preview();
  }

  /* Pills for the dropdown: the full match first, then values whose name starts with what was typed. */
  function suggestions(q) {
    var out = [], seen = {}, p = parse(q), qn = norm(q);
    if (p.hits.length) {
      var label = p.hits.map(hitLabel).join(' + ');
      out.push({ eyebrow: p.hits.length > 1 ? 'Browse' : KEYS[p.hits[0].g.key], name: label, url: urlFor(p.hits) });
      if (p.hits.length === 1) seen[p.hits[0].g.key + '|' + p.hits[0].v.v] = 1;
    }
    if (qn.length >= 3) {
      var pre = (cands || []).filter(function (c) { return c.w.indexOf(qn) === 0 || c.w.indexOf(' ' + qn) > 0; });
      pre.sort(function (a, b) { return ORDER.indexOf(a.g.key) - ORDER.indexOf(b.g.key) || (b.v.basic ? 1 : 0) - (a.v.basic ? 1 : 0); });
      pre.forEach(function (c) {
        var k = c.g.key + '|' + c.v.v;
        if (seen[k] || out.length >= 4) return;
        seen[k] = 1;
        var own = { g: c.g, v: c.v, w: norm(c.v.v) };
        out.push({ eyebrow: KEYS[c.g.key], name: hitLabel(own), url: urlFor([own]) });
      });
    }
    return out;
  }

  /* Does a title contain every searched word? Words match as the start of a title word (the last word may be
     half-typed), and plurals count ("keychains" matches "Keychain", "witches" matches "Witch").
     Titles include "by Author", so author searches count. */
  var SKIP = { the: 1, and: 1, book: 1, books: 1, by: 1, of: 1, a: 1, an: 1 };
  function qWords(q) { return norm(q).split(' ').filter(function (w) { return w.length > 1 && !SKIP[w]; }); }
  function wordIn(t, w) {
    if (t.indexOf(' ' + w) > -1) return true;
    if (w.length > 3 && /s$/.test(w)) {
      if (t.indexOf(' ' + w.slice(0, -1)) > -1) return true;
      if (/es$/.test(w) && t.indexOf(' ' + w.slice(0, -2)) > -1) return true;
    }
    return false;
  }
  function titleMatch(words, title) {
    var t = ' ' + norm(title) + ' ';
    return words.every(function (w) { return wordIn(t, w); });
  }
  function closeMatch(q, titles) {
    var words = qWords(q);
    if (!words.length) return true;
    return titles.some(function (t) { return titleMatch(words, t); });
  }
  function requestHref(q) { return '/pages/request-a-book?book=' + encodeURIComponent(q.trim()); }
  function shortQ(q) { q = q.trim(); return q.length > 40 ? q.slice(0, 38) + '…' : q; }

  /* Dropdown: when nothing listed matches what was typed, offer to order it — at the top, so people see it
     without pressing Enter. Not shown for filter searches ("enemies to lovers"), which get the Browse pills,
     or for series names, which get the series list. */
  function injectOrder(listbox, q) {
    if (listbox.querySelector('[data-rbreq-ac]') || q.trim().length < 3) return;
    var p = parse(q);
    if (p.hits.length && !p.rest.length) return;
    if (seriesMatch(q)) return;
    var titles = [].map.call(listbox.querySelectorAll('li.predictive-search__list-item'), function (li) { return li.textContent; });
    if (closeMatch(q, titles)) return;
    var html = '<div class="rbreq-ac" data-rbreq-ac><ul class="list-unstyled rbreq-ac__list" role="group" aria-label="Special order">' +
      '<li id="rbreq-ac-opt" class="rbreq-ac__item" role="option" aria-selected="false"><a class="rbreq-ac__link" tabindex="-1" href="' + esc(requestHref(q)) + '">' +
      '<span class="rbreq-ac__text"><span class="rbreq-ac__title">Don’t see it? We can order “' + esc(shortQ(q)) + '”</span>' +
      '<span class="rbreq-ac__sub">Send us a request and we’ll check availability for you</span></span>' +
      '<span class="rbst__go" aria-hidden="true">&rarr;</span></a></li></ul></div>';
    var pills = listbox.querySelector('[data-rbst]');
    if (pills) pills.insertAdjacentHTML('afterend', html); else listbox.insertAdjacentHTML('afterbegin', html);
  }

  function inject(box) {
    var ps = box.closest('predictive-search'), input = ps && ps.querySelector('input[type="search"]');
    var listbox = box.querySelector('#predictive-search-results');
    if (!input || !listbox) return;
    injectOrder(listbox, input.value);
    injectSeries(listbox, input.value);
    if (listbox.querySelector('[data-rbst]')) return;
    var s = suggestions(input.value);
    if (!s.length) return;
    var html = '<div class="rbst" data-rbst><h2 class="predictive-search__heading text-body caption-with-letter-spacing" id="rbst-h">Browse books</h2><ul class="rbst__list list-unstyled" role="group" aria-labelledby="rbst-h">';
    s.forEach(function (x, i) {
      html += '<li id="rbst-opt-' + i + '" class="rbst__item" role="option" aria-selected="false"><a class="rbst__link" tabindex="-1" href="' + esc(x.url) + '"><span class="rbst__eyebrow">' + esc(x.eyebrow) + '</span><span class="rbst__name">' + esc(x.name) + '</span><span class="rbst__go" aria-hidden="true">&rarr;</span></a></li>';
    });
    listbox.insertAdjacentHTML('afterbegin', html + '</ul></div>');
  }

  function watch() {
    document.querySelectorAll('[data-predictive-search]').forEach(function (box) {
      if (box.__rbst) return;
      box.__rbst = 1;
      new MutationObserver(function () { if (cands && series) inject(box); else bothReady.then(function () { inject(box); }); }).observe(box, { childList: true });
    });
  }

  /* Enter on a filter-only search goes straight to the filtered book list; Enter on a series name opens the series. */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[role="search"]')) return;
    var ps = f.closest('predictive-search');
    if (ps && ps.querySelector('[aria-selected="true"]')) return;
    var input = f.querySelector('input[name="q"]');
    if (!input || !input.value.trim() || isTagSearch(input.value)) return;
    function go() {
      var p = parse(input.value);
      if (p.jump) return urlFor(p.hits);
      var s = seriesJump(input.value);
      return s ? seriesUrl(s.s) : null;
    }
    if (!cands || !series) {
      e.preventDefault();
      bothReady.then(function () { var u = go(); if (u) location.href = u; else f.submit(); });
      return;
    }
    var u = go();
    if (u) { e.preventDefault(); location.href = u; }
  }, true);

  /* Search results page reached some other way (old links, Google): same jumps. ?rbst=0 keeps the plain results.
     A series page (q = tag:"series:…") is drawn by sections/rb-series-results; here we only give it its proper name. */
  if (/^\/search\/?$/.test(location.pathname)) {
    var sp = new URLSearchParams(location.search), q = sp.get('q');
    if (q && isTagSearch(q)) {
      sready.then(function () {
        var m = q.match(/series:([a-z0-9-]+)/i), row = null;
        if (m && series) series.some(function (c) { if (c.row.s === m[1].toLowerCase()) { row = c.row; return true; } return false; });
        if (row && window.RBSER_PAGE) window.RBSER_PAGE.setName(row.n);
      });
    } else if (q && sp.get('rbst') !== '0' && (!sp.get('type') || sp.get('type') === 'product')) {
      bothReady.then(function () {
        var p = parse(q);
        if (p.jump) { location.replace(urlFor(p.hits)); return; }
        var s = seriesJump(q);
        if (s) { location.replace(seriesUrl(s.s)); return; }
        resultsPage(q);
      });
    } else if (q) {
      resultsPage(q);
    }
  }

  /* "We can order it" on search results. Big card when nothing matches every searched word; a quiet line when
     books match (someone may want another edition). Nothing for merch-only matches ("keychain"). */
  function requestCard(q, matched, books) {
    var head = document.querySelector('.template-search__search');
    if (!head) return;
    var old = document.querySelector('[data-rbreq]');
    if (old) old.remove();
    var href = requestHref(q), html;
    if (!matched) {
      html = '<div class="rbreq" role="note" data-rbreq><p class="rbreq__kicker">Not finding it?</p><p class="rbreq__text">If we don’t carry the book you’re looking for, we can usually order it. Send us a request and we’ll check availability and get back to you.</p><a class="button rbreq__btn" href="' + esc(href) + '">Request “' + esc(shortQ(q)) + '”</a></div>';
    } else if (books) {
      html = '<p class="rbreq-line" data-rbreq>Don’t see the edition you want? <a href="' + esc(href) + '">We can order it for you</a>.</p>';
    } else {
      return;
    }
    head.insertAdjacentHTML('afterend', html);
  }

  /* Results page: Shopify's full search pads real matches with loosely related items ("keychain" → 20 keychains
     plus lockets, mugs and t-shirts, "109 results"), while the dropdown shows only real matches. Here we gather the
     results (up to MAXP pages), show the real matches first with their true count, and put the rest under
     "You might also like", 24 at a time. Large genuine result sets (an author with 200 books) are left alone. */
  var MAXP = 6, MORE = 24;
  function resultsPage(q) {
    var words = qWords(q);
    /* Book cards show the title and the author as separate links (the theme hides "by Author" in the title),
       so match against every link in the card's text block: title + author. */
    function links(li) { var i = li.querySelector('.card__information'); return i ? [].map.call(i.querySelectorAll('a'), function (a) { return a.textContent.trim(); }).filter(Boolean) : []; }
    function title(li) { var l = links(li); if (l.length) return l.join(' '); var h = li.querySelector('.card__heading'); return h ? h.textContent : ''; }
    function isBook(li) { return links(li).length > 1 || / by /i.test(title(li)); }
    function key(li) { var a = li.querySelector('a[href*="/products/"]'); return a ? a.getAttribute('href').split('?')[0] : title(li); }
    function plain(li) {
      /* Cards from other pages aren't seen by the theme's scroll animations, so they'd stay invisible. */
      li.classList.remove('scroll-trigger', 'animate--slide-in');
      [].forEach.call(li.querySelectorAll('.scroll-trigger'), function (e) { e.classList.remove('scroll-trigger', 'animate--slide-in'); });
      return li;
    }
    function setCount(text) {
      [].forEach.call(document.querySelectorAll('#ProductCount, #ProductCountDesktop'), function (el) { el.textContent = text; });
    }
    function lastPage(root) {
      var n = 1;
      [].forEach.call((root || document).querySelectorAll('.pagination a[href*="page="], .pagination [aria-current="page"]'), function (a) {
        var m = (a.getAttribute('href') || '').match(/[?&]page=(\d+)/) || (a.textContent.match(/^\s*(\d+)\s*$/));
        if (m) n = Math.max(n, +m[1]);
      });
      return n;
    }

    function run() {
      var ul = document.querySelector('#product-grid ul.product-grid');
      if (!ul) { if (words.length && !document.querySelector('[data-rbreq]')) requestCard(q, false, false); return; }
      if (ul.__rbsr) return;
      ul.__rbsr = 1;
      var page = +(new URLSearchParams(location.search).get('page') || 1);
      var items = [].filter.call(ul.children, function (li) { return li.querySelector('.card__heading'); });
      if (!words.length) return;
      if (!items.length) { requestCard(q, false, false); return; }
      var pages = lastPage();
      var allMatch = items.every(function (li) { return titleMatch(words, title(li)); });
      /* Nothing to fix: one page of real matches, or a big set of real matches, or a later page someone linked to. */
      if (page > 1 || (allMatch && (pages === 1 || pages > MAXP))) {
        requestCard(q, true, items.some(isBook));
        return;
      }
      ul.setAttribute('aria-busy', 'true');
      var urls = [];
      for (var p = 2; p <= Math.min(pages, MAXP); p++) {
        var u = new URL(location.href);
        u.searchParams.set('page', p);
        urls.push(u.toString());
      }
      Promise.all(urls.map(function (u) {
        return fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (h) {
          var d = new DOMParser().parseFromString(h, 'text/html'), g = d.querySelector('#product-grid ul.product-grid');
          return g ? [].filter.call(g.children, function (li) { return li.querySelector('.card__heading'); }) : [];
        }).catch(function () { return []; });
      })).then(function (rest) {
        if (!document.body.contains(ul)) return; /* filters changed while loading; the new grid gets its own pass */
        var seen = {}, all = [];
        items.concat.apply(items, rest).forEach(function (li) { var k = key(li); if (!seen[k]) { seen[k] = 1; all.push(li); } });
        var hits = all.filter(function (li) { return titleMatch(words, title(li)); });
        var related = all.filter(function (li) { return hits.indexOf(li) < 0; });
        ul.removeAttribute('aria-busy');
        requestCard(q, hits.length > 0, hits.some(isBook));
        if (!related.length) return; /* all real matches across pages: leave the normal pages alone */

        var frag = document.createDocumentFragment();
        hits.forEach(function (li) { frag.appendChild(plain(document.importNode(li, true))); });
        var headText = hits.length ? 'You might also like' : 'Nothing matched “' + shortQ(q) + '” exactly — you might like these';
        var head = document.createElement('li');
        head.className = 'rbsr-head';
        head.innerHTML = '<h2 class="rbsr-head__title">' + esc(headText) + '</h2>';
        frag.appendChild(head);
        var shown = 0;
        function addRelated(target, before) {
          related.slice(shown, shown + MORE).forEach(function (li) { target.insertBefore(plain(document.importNode(li, true)), before || null); });
          shown = Math.min(related.length, shown + MORE);
        }
        var holder = document.createElement('li');
        holder.className = 'rbsr-more';
        ul.innerHTML = '';
        ul.appendChild(frag);
        addRelated(ul);
        if (shown < related.length) {
          holder.innerHTML = '<button type="button" class="button button--secondary rbsr-more__btn">Show more like this</button>';
          ul.appendChild(holder);
          holder.querySelector('button').addEventListener('click', function () {
            addRelated(ul, holder);
            if (shown >= related.length) holder.remove();
          });
        }
        var pag = document.querySelector('#product-grid .pagination-wrapper');
        if (pag) pag.style.display = 'none';
        setCount(hits.length ? hits.length + (hits.length === 1 ? ' result' : ' results') : 'No exact matches');
      });
    }

    function start() {
      if (!document.getElementById('rbsr-css')) {
        var st = document.createElement('style');
        st.id = 'rbsr-css';
        st.textContent =
          '#product-grid .rbsr-head, #product-grid .rbsr-more { width: 100% !important; max-width: 100% !important; flex: 0 0 100% !important; list-style: none; }' +
          '#product-grid .rbsr-head { margin: 2.4rem 0 .4rem; padding-top: 2.4rem; border-top: 1px solid rgba(170, 109, 107, .3); text-align: center; }' +
          '#product-grid .rbsr-head__title { margin: 0; font-family: var(--font-heading-family); font-size: 1.8rem; letter-spacing: .3rem; text-transform: uppercase; color: #854a4c; }' +
          '#product-grid .rbsr-more { margin-top: 1.6rem; text-align: center; }' +
          '#product-grid ul[aria-busy="true"] { opacity: .6; transition: opacity .2s; }';
        document.head.appendChild(st);
      }
      run();
      /* Filters and sorting re-draw the grid without a page load. */
      var box = document.getElementById('ProductGridContainer');
      if (box && !box.__rbsrObs) {
        box.__rbsrObs = 1;
        new MutationObserver(function () { run(); }).observe(box, { childList: true, subtree: true });
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  }

  /* Rotating example placeholders. */
  function rotate() {
    document.querySelectorAll('[data-rbst-rotate]').forEach(function (inp) {
      if (inp.__rbstr) return;
      inp.__rbstr = 1;
      var list = inp.dataset.rbstRotate.split('|'), i = 0;
      setInterval(function () {
        if (inp.value || document.activeElement === inp) return;
        i = (i + 1) % list.length;
        inp.setAttribute('placeholder', list[i]);
      }, 3200);
    });
  }

  /* Request a Book page: ?book=Title (from the "We can order it" card on search results) fills in the comment box. */
  function prefillRequest() {
    if (!/^\/pages\/request-a-book\/?$/.test(location.pathname)) return;
    var t = new URLSearchParams(location.search).get('book'), box = document.getElementById('ContactForm-body');
    if (t && box && !box.value) box.value = 'Book request: ' + t.slice(0, 200) + '\nAuthor (if you know it): ';
  }

  function init() { watch(); rotate(); prefillRequest(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
